import React from 'react';
import Grid from '@material-ui/core/Grid';

import jason from './images/Pillnotes_Home_Jason.png';
import michelle from './images/Pillnotes_Home_Michelle.png';
import greta from './images/Pillnotes_Home_Greta.png';
import michael from './images/Pillnotes_Home_Michael.png';
import austin from './images/Pillnotes_Home_Austin.png';
import cat from './images/Pillnotes_Home_Cat.png';
import gabi from './images/Pillnotes_Home_Gabi.png';

import './css/studentroll.css';

class StudentRoll extends React.Component {
    render(){
        return (
            <div>
                <Grid container justify="center" alignItems="center">
                    <Grid item>
                        <img src={jason} className="student-img" />
                        <div className="student-name">Jason</div>
                        <div className="student-title">Team Lead</div>
                    </Grid>

                    <Grid item>
                        <img src={michelle} className="student-img" />
                        <div className="student-name">Michelle</div>
                        <div className="student-title">CTO</div>
                    </Grid>

                    <Grid item>
                        <img src={greta} className="student-img" />
                        <div className="student-name">Greta</div>
                        <div className="student-title">Software Developer</div>
                    </Grid>

                    <Grid item>
                        <img src={michael} className="student-img" />
                        <div className="student-name">Michael</div>
                        <div className="student-title">Software Developer</div>
                    </Grid>
                
                    <Grid item>
                        <img src={austin} className="student-img" />
                        <div className="student-name">Austin</div>
                        <div className="student-title">Software Developer</div>
                    </Grid>

                    <Grid item>
                        <img src={cat} className="student-img" />
                        <div className="student-name">Cat</div>
                        <div className="student-title">User Research</div>
                    </Grid>

                    <Grid item>
                        <img src={gabi} className="student-img" />
                        <div className="student-name">Gabi</div>
                        <div className="student-title">User Research</div>
                    </Grid>
                </Grid>
            </div>
        );
    }

}
export default StudentRoll;


// WEBPACK FOOTER //
// ./src/LandingPage/StudentRoll.js